import axios from './axios'

export const createChatbotFeedback = (data) =>
  axios.post('/chatbot_feedbacks', {
    message_id: data.message_id,
    query: data.query,
    bot_response: data.bot_response,
    feedback: data.feedback,
    role: data.role,
    person_id: data.person_id,
    room_id: data.room_id
  })
